import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const toc = [
  { id: 'intro', label: 'Introduction' },
  { id: 'data', label: 'Data We Collect' },
  { id: 'use', label: 'Use of Information' },
  { id: 'sharing', label: 'Sharing Information' },
  { id: 'cookies', label: 'Cookies' },
  { id: 'security', label: 'Security' },
  { id: 'rights', label: 'Your Rights' },
  { id: 'returns', label: 'Return Policy' },
  { id: 'contact', label: 'Contact' },
];

export default function Privacy() {
  return (
    <div style={{ fontFamily: "'Nunito', sans-serif" }}>
      <Navbar />

      <section className="pt-28 pb-10" style={{ backgroundColor: '#FFF7F0' }}>
        <div className="max-w-4xl mx-auto px-6">
          <span className="text-brand-purple text-xs font-600 uppercase tracking-widest" style={{ fontWeight: 600 }}>Legal</span>
          <h1 className="text-4xl font-700 text-gray-800 mt-2" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
            Privacy Policy
          </h1>
          <p className="text-gray-400 text-sm mt-2">Last updated: March 23, 2026</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-4xl mx-auto px-6 flex flex-col lg:flex-row gap-12">
          <aside className="lg:w-56 flex-shrink-0">
            <div className="bg-white rounded-2xl p-5 sticky top-28">
              <p className="text-xs font-700 text-gray-700 uppercase tracking-wider mb-4" style={{ fontWeight: 700 }}>Contents</p>
              <nav className="space-y-2">
                {toc.map(item => (
                  <a key={item.id} href={`#${item.id}`} className="block text-sm text-gray-500 hover:text-brand-yellow transition-colors cursor-pointer">
                    {item.label}
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          <div className="flex-1 prose-sm max-w-none space-y-10">
            <div id="intro">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#intro" className="text-gray-800 hover:text-brand-yellow">Introduction</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                At <strong>Little Loop</strong> ("we", "our", "the store") we respect and protect your privacy. This policy describes how we collect, use, and protect the personal information you provide when you visit our website or make a purchase.
              </p>
            </div>

            <div id="data">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#data" className="text-gray-800 hover:text-brand-yellow">Data We Collect</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed mb-3">We may collect the following types of information:</p>
              <ul className="text-sm text-gray-500 space-y-2 list-none pl-4">
                {[
                  'Contact information: name, email address, phone number.',
                  'Shipping information: postal address, city, state, ZIP code.',
                  'Browsing information: pages visited, time on site, device type.',
                  'Communications: messages you send us through the contact form.',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-brand-green text-base flex-shrink-0 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div id="use">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#use" className="text-gray-800 hover:text-brand-yellow">Use of Information</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed mb-3">We use your information to:</p>
              <ul className="text-sm text-gray-500 space-y-2 list-none pl-4">
                {[
                  'Process and manage your orders for second-hand clothing and used toys.',
                  'Communicate with you about your order or inquiry status.',
                  'Send you special offers and news, if you have opted in.',
                  'Improve our website and shopping experience.',
                  'Comply with legal and tax obligations.',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-brand-green text-base flex-shrink-0 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div id="sharing">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#sharing" className="text-gray-800 hover:text-brand-yellow">Sharing Information</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                We do not sell, rent, or market your personal information to third parties. We may share data with trusted service providers who help us operate the website (such as shipping services), always under confidentiality agreements. We will only disclose your information if required by law or to protect our legal rights.
              </p>
            </div>

            <div id="cookies">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#cookies" className="text-gray-800 hover:text-brand-yellow">Cookies</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                Our site may use cookies to improve your browsing experience. Cookies are small text files stored in your browser. You can configure your browser to reject them, though this may affect some site features such as the shopping cart.
              </p>
            </div>

            <div id="security">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#security" className="text-gray-800 hover:text-brand-yellow">Security</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                We implement reasonable security measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of internet transmission is 100% secure. We use HTTPS protocol throughout the site.
              </p>
            </div>

            <div id="rights">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#rights" className="text-gray-800 hover:text-brand-yellow">Your Rights</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed mb-3">You have the right to:</p>
              <ul className="text-sm text-gray-500 space-y-2 list-none pl-4">
                {[
                  'Access the personal data we hold about you.',
                  'Request correction of inaccurate data.',
                  'Request deletion of your personal data.',
                  'Withdraw consent to receive marketing communications.',
                  'Lodge a complaint with the relevant data protection authority.',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-brand-green text-base flex-shrink-0 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div id="returns" className="bg-brand-yellow-pale rounded-2xl p-6">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#returns" className="text-gray-800 hover:text-brand-yellow">Return Policy</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed mb-3">
                At Little Loop we accept returns within <strong>14 calendar days</strong> of receiving your order, under the following conditions:
              </p>
              <ul className="text-sm text-gray-500 space-y-2 list-none pl-4 mb-3">
                {[
                  'The item must be in the same condition as received.',
                  'Must include original or equivalent packaging.',
                  'You must contact us before sending the return.',
                  'Return shipping costs are the buyer\'s responsibility, unless the error is ours.',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-brand-green text-base flex-shrink-0 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-sm text-gray-500 leading-relaxed">
                Once the return is received and approved, we will process the refund within 5–7 business days to the original payment method. To start a return, email us at <strong>returns@littleloop.com</strong>.
              </p>
            </div>

            <div id="contact">
              <h4 className="text-lg font-700 text-gray-800 mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
                <a href="#contact" className="text-gray-800 hover:text-brand-yellow">Contact</a>
              </h4>
              <p className="text-sm text-gray-500 leading-relaxed">
                If you have questions about this Privacy Policy or how we handle your data, please contact us at:
                <br /><br />
                <strong>Little Loop</strong><br />
                271 Rue Duvernay, Beloeil, QC J3G 2M3<br />
                Email: privacy@littleloop.com<br />
                Phone: +1 (555) 012-3456
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
